import OutOfStock from '@components/Fireboard/components/Body/OutOfStock';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useOutletContext } from 'react-router-dom';
import { getObjectValue } from '@utility/utills';
import { useEffect, useState } from 'react';
import { setErrorPopUp, setNotification } from '@reducers/notification';
import {
  getOutOfStockItemList,
  getOutOfStockModifierList,
  updateModifierStock,
  updateItemStock,
  searchItemStock,
  searchModifierStock,
} from '../../../reducers/fireboard/outOfStock';
import { PopupContent } from '../../../components/common/Popup/index';
import Popup from '@components/common/Popup/Popup';
import constant from '@components/common/globalization';
import StockStatusConfirmationPopup from '../../../components/Fireboard/components/Body/OutOfStock/StockStatusConfPopup';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const OutOfStoke = props => {
  const { getPopup, popup, setPopup } = useOutletContext();

  const [outOfStockItems, setOutOfStockItems] = useState([]);
  const [selectedTab, setSelectedTab] = useState('items');
  const [selectedItems, setSelectedItems] = useState([]);
  const [outOfStockSearchList, setOutOfStockSearchList] = useState(null);
  const [selectedSearchItems, setSelectedSearchItems] = useState();
  const [cartItems, setCartItems] = useState([]);
  const storeInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem('auth'), false)
  );

  const getOutOfStockList = (type, isSync) => {
    getPopup('spinner');
    let reqFn = props.getOutOfStockItemList;
    if (type === 'modifiers') reqFn = props.getOutOfStockModifierList;

    reqFn({
      storeId: storeInfo?.id,
    })
      .then(res => {
        setOutOfStockItems(res);
        setPopup(null);
        isSync
          ? props.setNotification({
              type: 'success',
              message: FLABEL().TOAST_SUCCESS,
            })
          : '';
      })
      .catch(error => {
        props.setErrorPopUp({
          res: error.message,
        });
      });
  };

  const getConfirmation = item => {
    setSelectedSearchItems(item);
    setPopup({ type: constant.UPDATE_STOCK_STATUS });
  };

  const proceedItemStatusUpdate = (item, isCartType, backInStockDate) => {
    if (isCartType) {
      // handle add to cart after proceed
      const updatedItem = {
        ...item,
        ...(backInStockDate && {
          backInStockDate: new Date(backInStockDate).toISOString(),
        }),
      };
      setPopup(null);
      setCartItems(prevItems => [...prevItems, updatedItem]);
    } else {
      invokeItemStatusUpdateApi();
    }
  };

  const invokeItemStatusUpdateApi = backInStockDate => {
    getPopup('spinner');

    const request =
      selectedTab === 'modifiers'
        ? props.updateModifierStock
        : props.updateItemStock;
    const itemsToUpdate = backInStockDate ? cartItems : selectedItems;

    const promises = itemsToUpdate.map(item => {
      const payload = {
        storeId: storeInfo?.id,
        id: item.id,
        stocked: !item.stocked,
      };

      if (item?.backInStockDate) {
        payload['backInStockDate'] = new Date(
          item?.backInStockDate
        ).toISOString();
      }
      return request(payload);
    });

    Promise.all(promises)
      .then(res => {
        setPopup(null);
        setSelectedItems([]);
        setCartItems([]);
        getOutOfStockList(selectedTab);
        setOutOfStockSearchList([]);
        props.setNotification({
          type: 'success',
          message: res[0]?.stocked
            ? FLABEL().TOAST_MARK_INSTOCK
            : FLABEL().TOAST_MARK_OUTOFSTOCK,
        });
      })
      .catch(error => {
        setPopup(null);
        props.setErrorPopUp({ res: error.message });
      });
  };

  const searchOutOfStockItems = (type, value) => {
    getPopup('spinner', 'Searching items');
    const { id } = storeInfo;
    let req = props.searchItemStock;
    if (type === 'modifiers') req = props.searchModifierStock;
    req({
      storeId: id,
      postId: null,
      name: value,
      includeUnavailable: false,
    })
      .then(res => {
        setOutOfStockSearchList(res);
        setPopup(null);
      })
      .catch(error => {
        setPopup(null);
        props.setErrorPopUp({
          res: error.message,
        });
      });
  };

  useEffect(() => {
    getOutOfStockList(selectedTab);
  }, []);

  const onReloadOutOfStock = () => {
    getOutOfStockList(selectedTab, true);
  };

  const OnChangeTab = key => {
    getOutOfStockList(key);
    setSelectedTab(key);
    setSelectedItems([]);
    setOutOfStockSearchList(null);
    setCartItems([]);
  };

  const getPopupContent = () => {
    if (!popup) return null;
    switch (popup.type) {
      case constant.UPDATE_STOCK_STATUS:
        return (
          <StockStatusConfirmationPopup
            setPopup={setPopup}
            stocked={
              selectedSearchItems?.stocked ?? selectedSearchItems?.[0]?.stocked
            }
            onProceed={proceedItemStatusUpdate}
            selectedSearchItems={selectedSearchItems}
            selectedTab={selectedTab}
          />
        );

      default: {
        return <PopupContent {...popup} />;
      }
    }
  };

  return (
    <div className="h-100">
      <OutOfStock
        {...props}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        OnChangeTab={OnChangeTab}
        outOfStockItems={outOfStockItems}
        onReloadOutOfStock={onReloadOutOfStock}
        setSelectedItems={setSelectedItems}
        selectedItems={selectedItems}
        searchOutOfStockItems={searchOutOfStockItems}
        outOfStockSearchList={outOfStockSearchList}
        setPopup={setPopup}
        getConfirmation={getConfirmation}
        cartItems={cartItems}
        setCartItems={setCartItems}
        invokeItemStatusUpdateApi={invokeItemStatusUpdateApi}
      />
      <Popup visible={!!popup} fullPopupView={false}>
        {getPopupContent()}
      </Popup>
    </div>
  );
};

const mapStateToProps = ({ oauth }) => ({
  currentView: oauth.currentView,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setErrorPopUp,
      setNotification,
      getOutOfStockItemList,
      getOutOfStockModifierList,
      updateModifierStock,
      updateItemStock,
      searchItemStock,
      searchModifierStock,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(OutOfStoke);
